import { put, call, select } from 'redux-saga/effects';
import * as appActions from '../actions';
import * as selectors from '../reducers/selectors';

import { t } from '@lingui/core/macro';
export function* makeAPICall(
  verb,
  baseURL,
  path,
  data,
  successAction,
  authRequired = true,
  wasLogin = false
) {
  // If data is FormData, we must not set Content-Type (browser will set multipart boundary)
  const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;

  let config = {
    headers: {} as Record<string, string>,
  };

  if (!isFormData) {
    config.headers['Content-Type'] = 'application/json';
  }

  if (authRequired) {
    const auth = yield select(selectors.getAuth);
    config.headers.Authorization = `Bearer ${auth.token}`;
  }

  let url = `${baseURL}${path}`;
  let fetchOptions: any = {
    method: verb.toUpperCase(),
    headers: config.headers,
  };

  if (verb === 'post' || verb === 'put') {
    fetchOptions.body = isFormData ? data : JSON.stringify(data);
  }

  let response, responseData;
  try {
    response = yield call(fetch, url, fetchOptions);
    responseData = yield call([response, 'json']);
    if (!response.ok) {
      const error = { response: { status: response.status, data: responseData } };
      throw error;
    }
    yield put({ type: successAction, payload: responseData });
    return responseData;
  } catch (error) {
    yield handleAPIError(error, wasLogin);
    throw error;
  }
}

export function* handleAPIError(error, wasLogin) {
  yield put({ type: appActions.SET_APP_STATE, payload: { saving: false } });
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    if (error.response.status === 401) {
      yield put({
        type: appActions.SET_NAV,
        payload: { index: 'login', drawerOpen: false, activeStepperDepth: 0 },
      });
      if (wasLogin) {
        yield put({
          type: appActions.SHOW_ALERT,
          payload: { msg: t`Your login credentials are not valid`, type: 'error' },
        });
      } else {
        yield put({
          type: appActions.SHOW_ALERT,
          payload: { msg: t`Your login has expired, please login again`, type: 'error' },
        });
      }
    } else {
      const msg = error.response.data.message ? error.response.data.message : t`There was a server error on your last request`;
      yield put({ type: appActions.SHOW_ALERT, payload: { msg: msg, type: 'error' } });
    }
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log('Request failed: ', error.request);
    const msg = error.response.data.message ? error.response.data.message : t`There was a server error on your last request`;
    yield put({ type: appActions.SHOW_ALERT, payload: { msg: msg, type: 'error' } });
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log('Error', error.message);
    const msg =
      error.response && error.response.date && error.response.data.message
        ? error.response.data.message
        : t`There was a server error on your last request`;
    yield put({ type: appActions.SHOW_ALERT, payload: { msg: msg, type: 'error' } });
  }

  yield put({ type: appActions.CLEAR_ALL_UPDATES, payload: {} });
}
